import React, { useEffect } from "react";
import { APP_LINK_REQUEST_SUCCESS_PHONE} from "../../CONSTANTS";
import { useSearchParams } from "react-router-dom";
import { isMobile } from "../../Utils";

function ChangePhoneSuccess() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("numberChangeValidationToken");

  useEffect(()=> {
    if (isMobile()){
      window.location.href = `${APP_LINK_REQUEST_SUCCESS_PHONE}${token}`;
      return null;
    }
  }, [token])
  return null;
}

export default ChangePhoneSuccess;
